import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';

enableProdMode();

(<any>document).logger = function () {
  var oldConsoleLog = null;
  var oldConsoleInfo = null;
  var oldConsoleError = null;
  var oldConsoleDebug = null;
  var oldConsoleWarn = null;
  var pub = {};

  (<any>pub).enableLogger = function enableLogger() {
    if (oldConsoleLog == null || oldConsoleInfo == null || oldConsoleError == null || oldConsoleDebug == null || oldConsoleWarn == null) {
      return;
    }

    window['console']['log'] = oldConsoleLog;
    window['console']['info'] = oldConsoleInfo;
    window['console']['error'] = oldConsoleError;
    window['console']['debug'] = oldConsoleDebug;
    window['console']['warn'] = oldConsoleWarn;
  };

  (<any>pub).disableLogger = function disableLogger() {
    oldConsoleLog = console.log;
    oldConsoleInfo = console.info;
    oldConsoleError = console.error;
    oldConsoleDebug = console.debug;
    oldConsoleWarn = console.warn;

    window['console']['log'] = function () { };
    window['console']['info'] = function () { };
    window['console']['error'] = function () { };
    window['console']['debug'] = function () { };
    window['console']['warn'] = function () { };
  };

  return pub;
}();

// disable all console.log statements for performance reasons.
// If you want to see your los statements, surround you log statments with:
// logger.enableLogger(); console.log("sometext"); logger.disableLogger();
// IMPORTANT: before committing to master, make sure there are no actual
// logging statements slowing down our execution in production mode

((<any>document).logger).disableLogger();
//((<any>document).logger).enableLogger();

platformBrowserDynamic().bootstrapModule(AppModule);



// WEBPACK FOOTER //
// ./src/main.ts